import axios from 'axios'
import type { CreateContractRequest, CreateContractResponse, InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import type { GenericQueryOptions } from 'BrokerTsLib/src/hooks'
import { useMutation, useQuery } from '@tanstack/react-query'

import { baseUrl } from '.'
import type { OkAppsMeetingRecord } from '../dtos/OkAppsMeetingRecord'

const wizardApiUrl = import.meta.env.VITE_WIZARD_ADDON_API
const url = `${baseUrl}/${wizardApiUrl}`

export const useSaveInsuranceParams = () =>
  useMutation({ mutationFn: (insuranceParams: InsuranceParamsDto) =>
    axios.post(`${url}/SaveInsuranceParams`, insuranceParams) })

const fetchInsuranceParams = (paramsId: string) =>
  axios.get<InsuranceParamsDto>(`${url}/GetInsuranceParams?paramsId=${paramsId}`)

export const useGetInsuranceParamsAddon = (paramsId: string, options?: GenericQueryOptions<InsuranceParamsDto>) =>
  useQuery({ queryKey: ['getInsuranceParams', paramsId], queryFn: () => fetchInsuranceParams(paramsId), ...options })

export const useSaveSelectedAddonInsurance = () =>
  useMutation({ mutationFn: (paramsId: number) =>
    axios.post(`${url}/SaveSelectedAddonInsurance?paramsId=${paramsId}`, undefined) })

const saveMeetingRecord = (meetingRecord: OkAppsMeetingRecord) =>
  axios.post(`${url}/SaveMeetingRecord`, meetingRecord)

export const useSaveMeetingRecord = () =>
  useMutation({ mutationFn: saveMeetingRecord })

const createContract = (request: CreateContractRequest) =>
  axios.post<CreateContractResponse>(`${url}/CreateContract`, request)

export const useCreateContract = () =>
  useMutation({ mutationFn: createContract })
